"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var idlUtils = require("../generated/utils");

var nwmatcher = require("nwmatcher/src/nwmatcher-noqsa");

var DOMException = require("../../web-idl/DOMException");

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var NODE_TYPE = require("../node-type");

var createHTMLCollection = require("../html-collection").create;

var updateHTMLCollection = require("../html-collection").update;

var memoizeQuery = require("../../utils").memoizeQuery;

var createStaticNodeList = require("../node-list").createStatic; // nwmatcher gets `document.documentElement` at creation-time, so we have to initialize lazily, since in the initial
// stages of Document initialization, there is no documentElement present yet.


function addNwmatcher(parentNode) {
  var document = parentNode._ownerDocument;

  if (!document._nwmatcher) {
    document._nwmatcher = nwmatcher({
      document: document
    });

    document._nwmatcher.configure({
      UNIQUE_ID: false
    });
  }

  return document._nwmatcher;
}

var ParentNodeImpl = /*#__PURE__*/function () {
  function ParentNodeImpl() {
    _classCallCheck(this, ParentNodeImpl);
  }

  _createClass(ParentNodeImpl, [{
    key: "children",
    get: function get() {
      var _this = this;

      if (!this._childrenList) {
        this._childrenList = createHTMLCollection(this, function () {
          return domSymbolTree.childrenToArray(_this, {
            filter: function filter(node) {
              return node.nodeType === NODE_TYPE.ELEMENT_NODE;
            }
          });
        });
      } else {
        updateHTMLCollection(this._childrenList);
      }

      return this._childrenList;
    }
  }, {
    key: "firstElementChild",
    get: function get() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.childrenIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return child;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }, {
    key: "lastElementChild",
    get: function get() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = domSymbolTree.childrenIterator(this, {
          reverse: true
        })[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var child = _step2.value;

          if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return child;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return null;
    }
  }, {
    key: "childElementCount",
    get: function get() {
      return this.children.length;
    }
  }]);

  return ParentNodeImpl;
}();

ParentNodeImpl.prototype.querySelector = memoizeQuery(function (selectors) {
  var matcher = addNwmatcher(this);

  try {
    return matcher.first(selectors, idlUtils.wrapperForImpl(this));
  } catch (e) {
    throw new DOMException(DOMException.SYNTAX_ERR, e.message);
  }
});
ParentNodeImpl.prototype.querySelectorAll = memoizeQuery(function (selectors) {
  var matcher = addNwmatcher(this);
  var list;

  try {
    list = matcher.select(selectors, idlUtils.wrapperForImpl(this));
  } catch (e) {
    throw new DOMException(DOMException.SYNTAX_ERR, e.message);
  }

  return createStaticNodeList(list);
});
module.exports = {
  implementation: ParentNodeImpl
};